import { render, staticRenderFns } from "./MaterialRequisition.vue?vue&type=template&id=61aef34e&"
import script from "./MaterialRequisition.vue?vue&type=script&lang=js&"
export * from "./MaterialRequisition.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRequisition.vue?vue&type=style&index=0&id=61aef34e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports